import { render } from "./NotificationViewer.vue?vue&type=template&id=0f1cc1c2&scoped=true"
import script from "./NotificationViewer.vue?vue&type=script&lang=js"
export * from "./NotificationViewer.vue?vue&type=script&lang=js"

import "./NotificationViewer.vue?vue&type=style&index=0&id=0f1cc1c2&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f1cc1c2"]])

export default __exports__